import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import {
  getJourneyVisits,
  deleteVisit,
} from "../../../../../services/crm/salesJourney";
import { formatDate } from "../../../../../utils/utils";
import { Accordion, AccordionTab } from "primereact/accordion";
import VisitForm from "./visitForm";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import { Card as CardBootstrap, Badge } from "react-bootstrap";
import { Card } from "primereact/card";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { isMobile } from "react-device-detect";
function JourneyDetailData({ journey, history }) {
  const { reload } = useGlobalData();
  const [openVisitForm, setOpenVisitForm] = useState(false);
  const [visits, setVisits] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    if (journey.ID > 0) {
      getJourneyVisitsData(journey.ID);
    }
  }, [journey, reload]);

  const journeyVisitDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <CardBootstrap className="mb-3">
        <CardBootstrap.Header>
          <i className="fas fa-window-maximize"></i>
          <span>
            <strong>Sales Journey Header</strong>
          </span>
          <Badge
            className="float-right ml-1"
            variant={
              journey.statusID === 1
                ? "warning"
                : journey.statusID === 2
                ? "primary"
                : journey.statusID === 3
                ? "success"
                : journey.statusID === 9
                ? "danger"
                : null
            }
          >
            {journey.statusID !== 0 ? "Journey " + journey.statusDesc : null}
          </Badge>
        </CardBootstrap.Header>
        <CardBootstrap.Body>
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <CustomOutlinedDisabledTextField
                label="Sales Journey Name"
                value={journey.title}
              />
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Plan Start Date"
                    value={formatDate(journey.planStartDate)}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Plan End Date"
                    value={formatDate(journey.planEndDate)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Actual Start Date"
                    value={formatDate(journey.actStartDate, true)}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Actual End Date"
                    value={formatDate(journey.actEndDate, true)}
                  />
                </div>
              </div>
              <CustomOutlinedDisabledTextField
                label="Assigned To"
                value={journey.salesName}
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <CustomOutlinedDisabledTextField
                label="Description"
                value={journey.description}
                multiline
                minRows={7}
              />
            </div>
          </div>
        </CardBootstrap.Body>
      </CardBootstrap>
      <div className="accordion">
        <div className="card">
          <Accordion
            className="accordion"
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <AccordionTab
              header={
                <React.Fragment>
                  <i className="fas fa-sitemap"></i>
                  <span>
                    <strong>Sales Journey Visit Items</strong>
                  </span>
                </React.Fragment>
              }
            >
              {isMobile ? (
                <React.Fragment>
                  {visits.map((visit, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        history.push("/crm/visit-detail/" + visit.ID);
                      }}
                    >
                      <Card title={visit.visitTo}>
                        <table>
                          <tr>
                            <td>
                              {visit.statusID === 1 ? (
                                <Badge variant="warning">
                                  {visit.statusName}
                                </Badge>
                              ) : visit.statusID === 2 ? (
                                <Badge variant="primary">
                                  {visit.statusName}
                                </Badge>
                              ) : visit.statusID === 3 ? (
                                <Badge variant="success">
                                  {visit.statusName}
                                </Badge>
                              ) : visit.statusID === 9 ? (
                                <Badge variant="danger">
                                  {visit.statusName}
                                </Badge>
                              ) : (
                                <Badge variant="dark">{visit.statusName}</Badge>
                              )}
                            </td>
                            <td></td>
                          </tr>
                          {visit.salesCardID > 0 ? (
                            <tr>
                              <th>Sales Card</th>
                              <td>
                                {formatDate(visit.salesCard.salesCardName)}
                              </td>
                            </tr>
                          ) : null}
                          <tr>
                            <th>Plan Visit Date</th>
                            <td>{formatDate(visit.planVisitDate)}</td>
                          </tr>
                          <tr>
                            <th>Act Visit Date</th>
                            <td>{formatDate(visit.actVisitDate)}</td>
                          </tr>
                        </table>
                      </Card>
                    </div>
                  ))}
                </React.Fragment>
              ) : (
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <CustomDataTable
                      data={visits}
                      dataDetailColumns={journeyVisitDetailColumn}
                      onRefreshData={() => {
                        if (journey.ID > 0) {
                          getJourneyVisitsData(journey.ID);
                        }
                      }}
                      buttons={
                        journey.statusID === 1 || journey.statusID === 2
                          ? [
                              {
                                name: "Add Visit",
                                icon: "fas fa-plus-circle",
                                color: "primary",
                                onClick: () => {
                                  setOpenVisitForm(true);
                                },
                              },
                            ]
                          : []
                      }
                      columns={[
                        {
                          header: "Visit ID",
                          field: "ID",
                          body: null,
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Visit To",
                          field: "visitTo",
                          body: (rowData) => (
                            <React.Fragment>
                              <ResponsiveEllipsis
                                text={rowData.visitTo}
                                maxLine="1"
                              />
                            </React.Fragment>
                          ),
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Type",
                          field: "type",
                          body: null,
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Sales Card Name",
                          field: "salesCard.title",
                          body: (rowData) => (
                            <React.Fragment>
                              <ResponsiveEllipsis
                                text={rowData.salesCard.title}
                                maxLine="1"
                              />
                            </React.Fragment>
                          ),
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Visit Status",
                          field: "statusName",
                          body: (rowData) => {
                            if (rowData.statusID === 1) {
                              return (
                                <Badge variant="warning">
                                  {rowData.statusName}
                                </Badge>
                              );
                            } else if (rowData.statusID === 2) {
                              return (
                                <Badge variant="primary">
                                  {rowData.statusName}
                                </Badge>
                              );
                            } else if (rowData.statusID === 3) {
                              return (
                                <Badge variant="success">
                                  {rowData.statusName}
                                </Badge>
                              );
                            } else if (rowData.statusID === 9) {
                              return (
                                <Badge variant="danger">
                                  {rowData.statusName}
                                </Badge>
                              );
                            } else {
                              return (
                                <Badge variant="dark">
                                  {rowData.statusName}
                                </Badge>
                              );
                            }
                          },
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Plan Visit Date",
                          field: "planVisitDate",
                          body: (rowData) => formatDate(rowData.planVisitDate),
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Actual Visit Date",
                          field: "actVisitDate",
                          body: (rowData) =>
                            formatDate(rowData.actVisitDate, true, false),
                          sortable: true,
                          filter: true,
                        },
                        {
                          header: "Actions",
                          body: (rowData) => (
                            <React.Fragment>
                              <BootstrapTooltip title="Visit Detail">
                                <button
                                  type="button"
                                  onClick={() => {
                                    history.push(
                                      "/crm/visit-detail/" + rowData.ID
                                    );
                                  }}
                                  className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                                >
                                  <i className="fas fa-list-alt"></i>
                                </button>
                              </BootstrapTooltip>
                              {rowData.statusID === 1 ? (
                                <BootstrapTooltip title="Delete Visit">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      handleDeleteVisit(rowData.ID);
                                    }}
                                    className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                </BootstrapTooltip>
                              ) : null}
                            </React.Fragment>
                          ),
                          sortable: false,
                        },
                      ]}
                    />
                  </div>
                </div>
              )}
            </AccordionTab>
          </Accordion>
        </div>
      </div>
      <DialogLayout
        open={openVisitForm}
        title="Visit Form"
        onCloseDialog={handleCloseVisitForm}
        maxWIdth="md"
      >
        <VisitForm
          journeyID={journey.ID}
          onReloadVisits={() => {
            handleCloseVisitForm();
            getJourneyVisitsData(journey.ID);
          }}
          onCloseDialog={handleCloseVisitForm}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleDeleteVisit(visitID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Visit ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteVisit(visitID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getJourneyVisitsData(journey.ID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getJourneyVisitsData(journeyID) {
    const response = await getJourneyVisits(journeyID);
    const { data } = response.data;
    setVisits(data.visits);
  }

  function handleCloseVisitForm() {
    setOpenVisitForm(false);
  }
}

export default JourneyDetailData;
